import * as React from 'react';
import { Row, Column, GridContainer, FlexBox, Box, AlertBox } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import PropTypes from 'prop-types';
import ContinueShopping from './layout/layoutComponents/ContinueShopping';

export const ErrorPage = props => {
  const { errorMessage } = props;

  const [cartMessages] = useTranslations(['cartMessages']);

  return (
    <GridContainer>
      <Row>
        <Column span={6} offset={3}>
          <Box marginBottom="7">
            <FlexBox
              marginTop="5"
              marginBottom="7"
              justifyContent="left"
              alignItems="center"
              pt={9}
              pb="4"
            >
              <AlertBox skin="error">{errorMessage}</AlertBox>
            </FlexBox>
          </Box>
        </Column>
      </Row>
      <Row>
        <Column span={6} offset={3}>
          <Box marginBottom={9}>
            <ContinueShopping buttonText={cartMessages.continueShopping} />
          </Box>
        </Column>
      </Row>
    </GridContainer>
  );
};

ErrorPage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};
